<ng-container *ngIf="action$ | async"></ng-container>

<div *ngIf="panel$ | async as panel" class="flex flex-row space-x-3 items-center">
  <csl-item-card
    data-testid="handleItemCard"
    [cleanable]="!!getSetedHandle(panel)"
    [disabled]="disabled || notAvailableToAdd"
    [iconLink]="getSetedHandle(panel)?.cropTextureLink"
    (selectClicked)="changeHandle(panel)"
    (cleaned)="remove(panel)"
    i18n-title
    title="Ручка"
    [description]="getDescription(panel)"
    class="flex-1">
  </csl-item-card>

  <mat-form-field class="dense-input no-subscript basis-6/5" appearance="outline" *ngIf="!!getSetedHandle(panel)">
    <mat-label i18n>Расположение</mat-label>
    <mat-select [value]="getPosition(panel)" (selectionChange)="changePosition($event.value, panel)">
      <mat-option [value]="'tc'" [disabled]="topNotAvailableToAdd">
        <div [matTooltip]="topNotAvailableToAdd ? 'Не доступно из-за обработки угла' : ''" i18n>Сверху</div>
      </mat-option>
      <mat-option [value]="'bc'" [disabled]="bottomNotAvailableToAdd">
        <div [matTooltip]="bottomNotAvailableToAdd ? 'Не доступно из-за обработки угла' : ''" i18n>Снизу</div>
      </mat-option>
    </mat-select>
  </mat-form-field>
</div>
